function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Vue from 'vue';
import replayPointerEvent from './hydration/replayPointerEvent.mjs';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';

/* Plugins */

import nuxt_plugin_plugin_54604f30 from 'nuxt_plugin_plugin_54604f30'; // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_4de1dc0a from 'nuxt_plugin_sentryserver_4de1dc0a'; // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2faf2afc from 'nuxt_plugin_sentryclient_2faf2afc'; // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_403cc2af from 'nuxt_plugin_plugin_403cc2af'; // Source: ../node_modules/@pinia/nuxt/dist/runtime/plugin.vue2 (mode: 'all')
import nuxt_plugin_appplugin_6e4ae16c from 'nuxt_plugin_appplugin_6e4ae16c'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_4417b6a3 from 'nuxt_plugin_configplugin_4417b6a3'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_nitrobridgeserver_1ab611b4 from 'nuxt_plugin_nitrobridgeserver_1ab611b4'; // Source: ./nitro-bridge.server.mjs (mode: 'server')
import nuxt_plugin_nitrobridgeclient_6d7d5b88 from 'nuxt_plugin_nitrobridgeclient_6d7d5b88'; // Source: ./nitro-bridge.client.mjs (mode: 'client')
import nuxt_plugin_gtm_dbd73ac8 from 'nuxt_plugin_gtm_dbd73ac8'; // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_workbox_6cf6843c from 'nuxt_plugin_workbox_6cf6843c'; // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_313b02f5 from 'nuxt_plugin_metaplugin_313b02f5'; // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_ea6a7e96 from 'nuxt_plugin_pluginutils_ea6a7e96'; // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_8dc41680 from 'nuxt_plugin_pluginrouting_8dc41680'; // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e05a2a2 from 'nuxt_plugin_pluginmain_7e05a2a2'; // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74'; // Source: ./axios.js (mode: 'all')
import nuxt_plugin_capiplugin_2b56d48d from 'nuxt_plugin_capiplugin_2b56d48d'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_e4c11288 from 'nuxt_plugin_errorpluginserver_e4c11288'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_formatnumber_2db123ae from 'nuxt_plugin_formatnumber_2db123ae'; // Source: ../plugins/format-number (mode: 'client')
import nuxt_plugin_delayedJs_73924444 from 'nuxt_plugin_delayedJs_73924444'; // Source: ../plugins/delayedJs.client (mode: 'client')
import nuxt_plugin_uadevice_e764a3fe from 'nuxt_plugin_uadevice_e764a3fe'; // Source: ../plugins/ua-device (mode: 'all')
import nuxt_plugin_datalayeraxios_45b740da from 'nuxt_plugin_datalayeraxios_45b740da'; // Source: ../plugins/datalayer-axios (mode: 'all')
import nuxt_plugin_vuei18n_887a23e4 from 'nuxt_plugin_vuei18n_887a23e4'; // Source: ../lang/plugins/vue-i18n (mode: 'all')
import nuxt_plugin_language_6f8f8ef8 from 'nuxt_plugin_language_6f8f8ef8'; // Source: ../lang/plugins/language.client (mode: 'client')
import nuxt_plugin_pulocalepath_125874e6 from 'nuxt_plugin_pulocalepath_125874e6'; // Source: ../plugins/pu-locale-path (mode: 'all')
import nuxt_plugin_polyfill_423ed5d8 from 'nuxt_plugin_polyfill_423ed5d8'; // Source: ../plugins/polyfill.client (mode: 'client')
import nuxt_plugin_loadscript_55b1865c from 'nuxt_plugin_loadscript_55b1865c'; // Source: ../plugins/load-script (mode: 'all')
import nuxt_plugin_scrollto_49c28904 from 'nuxt_plugin_scrollto_49c28904'; // Source: ../plugins/scrollto (mode: 'client')
import nuxt_plugin_vueobservevisibility_9bd06b0e from 'nuxt_plugin_vueobservevisibility_9bd06b0e'; // Source: ../plugins/vue-observe-visibility.client (mode: 'client')
import nuxt_plugin_vuesnackbar_7c1493e2 from 'nuxt_plugin_vuesnackbar_7c1493e2'; // Source: ../plugins/vue-snackbar (mode: 'client')
import nuxt_plugin_globalgetlocale_910b1f36 from 'nuxt_plugin_globalgetlocale_910b1f36'; // Source: ../plugins/global-get-locale (mode: 'all')
import nuxt_plugin_eventbubble_2fa80595 from 'nuxt_plugin_eventbubble_2fa80595'; // Source: ../plugins/event-bubble (mode: 'client')
import nuxt_plugin_pulinksinversify_b0e94fbe from 'nuxt_plugin_pulinksinversify_b0e94fbe'; // Source: ../plugins/pu-links-inversify (mode: 'all')
import nuxt_plugin_authinterceptoraxios_5399108c from 'nuxt_plugin_authinterceptoraxios_5399108c'; // Source: ../plugins/auth-interceptor-axios.client (mode: 'client')
import nuxt_plugin_pwa_39df1e16 from 'nuxt_plugin_pwa_39df1e16'; // Source: ../plugins/pwa.client (mode: 'client')
import nuxt_plugin_uachange_203589be from 'nuxt_plugin_uachange_203589be'; // Source: ../plugins/ua-change.client (mode: 'client')
import nuxt_plugin_webvitals_1acc9e43 from 'nuxt_plugin_webvitals_1acc9e43'; // Source: ../plugins/web-vitals.client (mode: 'client')
import nuxt_plugin_searchgalleryposition_7d3a50f4 from 'nuxt_plugin_searchgalleryposition_7d3a50f4'; // Source: ../plugins/search-gallery-position.client (mode: 'client')
import nuxt_plugin_convertcom_042562e4 from 'nuxt_plugin_convertcom_042562e4'; // Source: ../plugins/convertcom (mode: 'all')
import nuxt_plugin_convertcom2_6dfac82a from 'nuxt_plugin_convertcom2_6dfac82a'; // Source: ../plugins/convertcom2.client (mode: 'client')
import nuxt_plugin_versiondebug_702d3b11 from 'nuxt_plugin_versiondebug_702d3b11'; // Source: ../plugins/version-debug.client (mode: 'client')
import nuxt_plugin_plugin_77e739b1 from 'nuxt_plugin_plugin_77e739b1'; // Source: ../apps/inversify/plugin (mode: 'all')
import nuxt_plugin_plugin_41bbb07b from 'nuxt_plugin_plugin_41bbb07b'; // Source: ../apps/inversify/router/plugin (mode: 'all')
import nuxt_plugin_plugin_e025b69e from 'nuxt_plugin_plugin_e025b69e'; // Source: ../modules/gtm/plugin (mode: 'server')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "fade",
  "mode": "out-in",
  "appear": false,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator(function* (ssrContext) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      console.time('[NuxtDelayHydration] Hydration time');
      performance.mark('start_hydration_time');
      var style = 'background: #e2f8e5; color: #2e9127;';
      console.log('%c[NuxtDelayHydration] Started delaying hydration with mode: "init"', style);
      var hydrationEvent = false;
      console.log("%c[NuxtDelayHydration] Finished delaying hydration with trigger: \"".concat(hydrationEvent, "\""), style);
      console.timeEnd('[NuxtDelayHydration] Hydration time');
      performance.mark('end_hydration_time');
      if (hydrationEvent) setTimeout(function () {
        requestIdleCallback(function () {
          replayPointerEvent(hydrationEvent, true);
        });
      }, 1000);
    }
    var store = null;
    var router = yield createRouter(ssrContext, config, {
      store
    });

    // Create Root instance

    // here we inject the router and store to all child components,
    // making them available everywhere as `this.$router` and `this.$store`.
    var app = _objectSpread({
      head: {
        "meta": [{
          "charset": "utf-8"
        }, {
          "hid": "robots",
          "name": "robots",
          "content": "max-image-preview:large"
        }, {
          "hid": "Accept-CH",
          "http-equiv": "Accept-CH",
          "content": "DPR, Viewport-Width, Width, ECT",
          "property": ""
        }, {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1"
        }, {
          "name": "google",
          "content": "notranslate"
        }, {
          "name": "application-name",
          "content": "Pitchup.com"
        }, {
          "name": "apple-mobile-web-app-title",
          "content": "Pitchup.com"
        }, {
          "name": "theme-color",
          "content": "#238338"
        }, {
          "name": "format-detection",
          "content": "telephone=no"
        }, {
          "name": "alfred-version",
          "content": "alfred@v1.17.980+45272"
        }, {
          "property": "og:type",
          "content": "website"
        }, {
          "property": "og:site_name",
          "content": "Pitchup.com"
        }, {
          "hid": "og:url",
          "property": "og:url",
          "content": "https:\u002F\u002Fwww.pitchup.com"
        }, {
          "property": "fb:app_id",
          "content": "127689162592"
        }, {
          "name": "twitter:card",
          "content": "summary"
        }, {
          "name": "twitter:site",
          "content": "@pitchup"
        }, {
          "hid": "og:image",
          "property": "og:image",
          "content": "https:\u002F\u002Fwww.pitchup.com\u002Fapp-icons\u002Fpitchup_logo_og.png"
        }, {
          "hid": "og:image:width",
          "property": "og:image:width",
          "content": "1200"
        }, {
          "hid": "og:image:height",
          "property": "og:image:height",
          "content": "630"
        }],
        "link": [{
          "rel": "preconnect",
          "href": "https:\u002F\u002Fwww.googletagmanager.com"
        }, {
          "hid": "dns-prefetch-cdn-cookieyes",
          "rel": "dns-prefetch",
          "href": "https:\u002F\u002Fcdn-cookieyes.com"
        }, {
          "hid": "dns-prefetch-directory-cookieyes",
          "rel": "dns-prefetch",
          "href": "https:\u002F\u002Fdirectory.cookieyes.com"
        }, {
          "hid": "preconnect-log-cookieyes",
          "rel": "preconnect",
          "href": "https:\u002F\u002Flog.cookieyes.com"
        }, {
          "hid": "dns-prefetch-log-cookieyes",
          "rel": "dns-prefetch",
          "href": "https:\u002F\u002Flog.cookieyes.com"
        }, {
          "rel": "icon",
          "type": "image\u002Fx-icon",
          "href": "https:\u002F\u002Fwww.pitchup.com\u002Ffavicon.ico"
        }, {
          "rel": "icon",
          "type": "image\u002Fpng",
          "sizes": "32x32",
          "href": "https:\u002F\u002Fwww.pitchup.com\u002Fapp-icons\u002Ffavicon-32x32.png"
        }, {
          "rel": "icon",
          "type": "image\u002Fpng",
          "sizes": "96x96",
          "href": "https:\u002F\u002Fwww.pitchup.com\u002Fapp-icons\u002Ffavicon-96x96.png"
        }, {
          "rel": "icon",
          "type": "image\u002Fpng",
          "sizes": "194x194",
          "href": "https:\u002F\u002Fwww.pitchup.com\u002Fapp-icons\u002Ffavicon-194x194.png"
        }],
        "style": [],
        "script": [{
          "hid": "gtm-script",
          "innerHTML": "if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"
        }],
        "__dangerouslyDisableSanitizersByTagID": {
          "gtm-script": ["innerHTML"],
          "gtm-noscript": ["innerHTML"]
        }
      },
      router,
      nuxt: {
        defaultTransition,
        transitions: [defaultTransition],
        setTransitions(transitions) {
          if (!Array.isArray(transitions)) {
            transitions = [transitions];
          }
          transitions = transitions.map(transition => {
            if (!transition) {
              transition = defaultTransition;
            } else if (typeof transition === 'string') {
              transition = Object.assign({}, defaultTransition, {
                name: transition
              });
            } else {
              transition = Object.assign({}, defaultTransition, transition);
            }
            return transition;
          });
          this.$options.nuxt.transitions = transitions;
          return transitions;
        },
        err: null,
        dateErr: null,
        error(err) {
          err = err || null;
          app.context._errored = Boolean(err);
          err = err ? normalizeError(err) : null;
          var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
          if (this) {
            nuxt = this.nuxt || this.$options.nuxt;
          }
          nuxt.dateErr = Date.now();
          nuxt.err = err;
          // Used in src/server.js
          if (ssrContext) {
            ssrContext.nuxt.error = err;
          }
          return err;
        }
      }
    }, App);
    var next = ssrContext ? ssrContext.next : location => app.router.push(location);
    // Resolve route
    var route;
    if (ssrContext) {
      route = router.resolve(ssrContext.url).route;
    } else {
      var path = getLocation(router.options.base, router.options.mode);
      route = router.resolve(path).route;
    }

    // Set context to app.context
    yield setContext(app, {
      route,
      next,
      error: app.nuxt.error.bind(app),
      payload: ssrContext ? ssrContext.payload : undefined,
      req: ssrContext ? ssrContext.req : undefined,
      res: ssrContext ? ssrContext.res : undefined,
      beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
      beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
      ssrContext
    });
    function inject(key, value) {
      if (!key) {
        throw new Error('inject(key, value) has no key provided');
      }
      if (value === undefined) {
        throw new Error("inject('".concat(key, "', value) has no value provided"));
      }
      key = '$' + key;
      // Add into app
      app[key] = value;
      // Add into context
      if (!app.context[key]) {
        app.context[key] = value;
      }

      // Check if plugin not already installed
      var installKey = '__nuxt_' + key + '_installed__';
      if (Vue[installKey]) {
        return;
      }
      Vue[installKey] = true;
      // Call Vue.use() to install the plugin into vm
      Vue.use(() => {
        if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
          Object.defineProperty(Vue.prototype, key, {
            get() {
              return this.$root.$options[key];
            }
          });
        }
      });
    }

    // Inject runtime config as $config
    inject('config', config);

    // Add enablePreview(previewData = {}) in context for plugins
    if (process.static && process.client) {
      app.context.enablePreview = function () {
        var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        app.previewData = Object.assign({}, previewData);
        inject('preview', previewData);
      };
    }
    // Plugin execution

    if (typeof nuxt_plugin_plugin_54604f30 === 'function') {
      yield nuxt_plugin_plugin_54604f30(app.context, inject);
    }
    if (process.server && typeof nuxt_plugin_sentryserver_4de1dc0a === 'function') {
      yield nuxt_plugin_sentryserver_4de1dc0a(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_sentryclient_2faf2afc === 'function') {
      yield nuxt_plugin_sentryclient_2faf2afc(app.context, inject);
    }
    if (typeof nuxt_plugin_plugin_403cc2af === 'function') {
      yield nuxt_plugin_plugin_403cc2af(app.context, inject);
    }
    if (typeof nuxt_plugin_appplugin_6e4ae16c === 'function') {
      yield nuxt_plugin_appplugin_6e4ae16c(app.context, inject);
    }
    if (typeof nuxt_plugin_configplugin_4417b6a3 === 'function') {
      yield nuxt_plugin_configplugin_4417b6a3(app.context, inject);
    }
    if (process.server && typeof nuxt_plugin_nitrobridgeserver_1ab611b4 === 'function') {
      yield nuxt_plugin_nitrobridgeserver_1ab611b4(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_nitrobridgeclient_6d7d5b88 === 'function') {
      yield nuxt_plugin_nitrobridgeclient_6d7d5b88(app.context, inject);
    }
    if (typeof nuxt_plugin_gtm_dbd73ac8 === 'function') {
      yield nuxt_plugin_gtm_dbd73ac8(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_workbox_6cf6843c === 'function') {
      yield nuxt_plugin_workbox_6cf6843c(app.context, inject);
    }
    if (typeof nuxt_plugin_metaplugin_313b02f5 === 'function') {
      yield nuxt_plugin_metaplugin_313b02f5(app.context, inject);
    }
    if (typeof nuxt_plugin_pluginutils_ea6a7e96 === 'function') {
      yield nuxt_plugin_pluginutils_ea6a7e96(app.context, inject);
    }
    if (typeof nuxt_plugin_pluginrouting_8dc41680 === 'function') {
      yield nuxt_plugin_pluginrouting_8dc41680(app.context, inject);
    }
    if (typeof nuxt_plugin_pluginmain_7e05a2a2 === 'function') {
      yield nuxt_plugin_pluginmain_7e05a2a2(app.context, inject);
    }
    if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
      yield nuxt_plugin_axios_80c87b74(app.context, inject);
    }
    if (typeof nuxt_plugin_capiplugin_2b56d48d === 'function') {
      yield nuxt_plugin_capiplugin_2b56d48d(app.context, inject);
    }
    if (process.server && typeof nuxt_plugin_errorpluginserver_e4c11288 === 'function') {
      yield nuxt_plugin_errorpluginserver_e4c11288(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_formatnumber_2db123ae === 'function') {
      yield nuxt_plugin_formatnumber_2db123ae(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_delayedJs_73924444 === 'function') {
      yield nuxt_plugin_delayedJs_73924444(app.context, inject);
    }
    if (typeof nuxt_plugin_uadevice_e764a3fe === 'function') {
      yield nuxt_plugin_uadevice_e764a3fe(app.context, inject);
    }
    if (typeof nuxt_plugin_datalayeraxios_45b740da === 'function') {
      yield nuxt_plugin_datalayeraxios_45b740da(app.context, inject);
    }
    if (typeof nuxt_plugin_vuei18n_887a23e4 === 'function') {
      yield nuxt_plugin_vuei18n_887a23e4(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_language_6f8f8ef8 === 'function') {
      yield nuxt_plugin_language_6f8f8ef8(app.context, inject);
    }
    if (typeof nuxt_plugin_pulocalepath_125874e6 === 'function') {
      yield nuxt_plugin_pulocalepath_125874e6(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_polyfill_423ed5d8 === 'function') {
      yield nuxt_plugin_polyfill_423ed5d8(app.context, inject);
    }
    if (typeof nuxt_plugin_loadscript_55b1865c === 'function') {
      yield nuxt_plugin_loadscript_55b1865c(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_scrollto_49c28904 === 'function') {
      yield nuxt_plugin_scrollto_49c28904(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_vueobservevisibility_9bd06b0e === 'function') {
      yield nuxt_plugin_vueobservevisibility_9bd06b0e(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_vuesnackbar_7c1493e2 === 'function') {
      yield nuxt_plugin_vuesnackbar_7c1493e2(app.context, inject);
    }
    if (typeof nuxt_plugin_globalgetlocale_910b1f36 === 'function') {
      yield nuxt_plugin_globalgetlocale_910b1f36(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_eventbubble_2fa80595 === 'function') {
      yield nuxt_plugin_eventbubble_2fa80595(app.context, inject);
    }
    if (typeof nuxt_plugin_pulinksinversify_b0e94fbe === 'function') {
      yield nuxt_plugin_pulinksinversify_b0e94fbe(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_authinterceptoraxios_5399108c === 'function') {
      yield nuxt_plugin_authinterceptoraxios_5399108c(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_pwa_39df1e16 === 'function') {
      yield nuxt_plugin_pwa_39df1e16(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_uachange_203589be === 'function') {
      yield nuxt_plugin_uachange_203589be(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_webvitals_1acc9e43 === 'function') {
      yield nuxt_plugin_webvitals_1acc9e43(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_searchgalleryposition_7d3a50f4 === 'function') {
      yield nuxt_plugin_searchgalleryposition_7d3a50f4(app.context, inject);
    }
    if (typeof nuxt_plugin_convertcom_042562e4 === 'function') {
      yield nuxt_plugin_convertcom_042562e4(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_convertcom2_6dfac82a === 'function') {
      yield nuxt_plugin_convertcom2_6dfac82a(app.context, inject);
    }
    if (process.client && typeof nuxt_plugin_versiondebug_702d3b11 === 'function') {
      yield nuxt_plugin_versiondebug_702d3b11(app.context, inject);
    }
    if (typeof nuxt_plugin_plugin_77e739b1 === 'function') {
      yield nuxt_plugin_plugin_77e739b1(app.context, inject);
    }
    if (typeof nuxt_plugin_plugin_41bbb07b === 'function') {
      yield nuxt_plugin_plugin_41bbb07b(app.context, inject);
    }
    if (process.server && typeof nuxt_plugin_plugin_e025b69e === 'function') {
      yield nuxt_plugin_plugin_e025b69e(app.context, inject);
    }

    // Lock enablePreview in context
    if (process.static && process.client) {
      app.context.enablePreview = function () {
        console.warn('You cannot call enablePreview() outside a plugin.');
      };
    }

    // Wait for async component to be resolved first
    yield new Promise((resolve, reject) => {
      // Ignore 404s rather than blindly replacing URL in browser
      if (process.client) {
        var {
          route: _route
        } = router.resolve(app.context.route.fullPath);
        if (!_route.matched.length) {
          return resolve();
        }
      }
      router.replace(app.context.route.fullPath, resolve, err => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err);
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

        // navigated to a different route in router guard
        var unregister = router.afterEach( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(function* (to, from) {
            if (process.server && ssrContext && ssrContext.url) {
              ssrContext.url = to.fullPath;
            }
            app.context.route = yield getRouteData(to);
            app.context.params = to.params || {};
            app.context.query = to.query || {};
            unregister();
            resolve();
          });
          return function (_x2, _x3) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    });
    return {
      app,
      router
    };
  });
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };